import { render, staticRenderFns } from "./JobBox.vue?vue&type=template&id=bcb09ba6&"
import script from "./JobBox.vue?vue&type=script&lang=js&"
export * from "./JobBox.vue?vue&type=script&lang=js&"
import style0 from "./JobBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports